export default "__VITE_ASSET__Cu5$ItYu__"